import axios from 'axios'

// const BASE_URL = 'http://api.cmg.sisgroup.sg'
let token = localStorage.getItem('accesstoken')
if (token) {
  axios.defaults.headers.common['accesstoken'] = `Bearer ${token}`
}
export const httpInstance = axios.create({
  baseURL: 'http://dev.api.cmg.sisgroup.sg/',
  headers: {
    'content-type': 'application/json',
    deviceid: '123456'
  }
})

export const pictureUploadInstance = axios.create({
  baseURL: 'http://dev.api.cmg.sisgroup.sg/',
  headers: {
    'content-type': 'multipart/form-data',
    deviceid: '123456'
  }
})



// WEBPACK FOOTER //
// ./src/api/index.js